import Vue from 'vue'
import App from './App.vue'
import client from './js/client';
import store from "./store";
import VueApiService from 'vue-api-service';
import VueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import endpoints from "./js/endpoints";
import alerts from "./js/alerts";
import router from "./js/router";
import { getRoutePageTitle } from './js/routeTitle';
import enums from "./js/enums";
import VueCookies from 'vue-cookies';
import modals from "./js/modals";
import DashboardPlugin from "./material-dashboard";
import VueBus from 'vue-bus';
import authImage from "./js/auth-image";
import UUID from "vue-uuid";
import i18n from './js/lang';

Vue.use(UUID);
Vue.use(VueBus);
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(DashboardPlugin);
Vue.use(VueApiService, {
  client,
  endpoints
});
Vue.use(authImage);

const gaMeasurementId = process.env.VUE_APP_GA_MEASUREMENT_ID;
if (gaMeasurementId) {
  Vue.use(VueGtag, {
    config: { id: gaMeasurementId },
    pageTrackerTemplate(to) {
      return {
        page_path: to.fullPath,
        page_title: getRoutePageTitle(to),
      };
    },
  }, router);
}

Vue.prototype.$alerts = alerts;
Vue.prototype.$enums = enums;
Vue.prototype.$modals = modals;

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
    i18n,
  router,
  store
}).$mount('#app')
